exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7bc548a0] .v-badge--overlap.v-badge--left .v-badge__badge{left:9px;top:0}[data-v-7bc548a0] .v-list__tile--avatar{padding-left:0;height:115px!important}", ""]);

// exports
